import React from 'react';

function Swap(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 14 12" fill="none">
            <path
                d="M3.82 0h.04a.3.3 0 0 1 .07.02l.04.01.03.01.04.02.03.01.03.02.03.02c.02 0 .03 0 .04.02a.3.3 0 0 1 .03.02l.03.02.05.05 3 3a.75.75 0 0 1-1.06 1.06L4.5 2.56v8.69a.75.75 0 1 1-1.5 0V2.56L1.28 4.28A.75.75 0 0 1 .22 3.22l3-3a.72.72 0 0 1 .35-.2h.03A.3.3 0 0 1 3.64 0h.04a.72.72 0 0 1 .14 0ZM11 .75v8.69l1.72-1.72a.75.75 0 0 1 1.06 1.06l-3 3a.72.72 0 0 1-.35.2h-.03a.3.3 0 0 1-.04.01h-.04a.74.74 0 0 1-.6-.21l-3-3a.75.75 0 0 1 1.06-1.06L9.5 9.44V.75a.75.75 0 1 1 1.5 0Z"
                fill={props.color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default Swap;
